import { defineStore } from 'pinia'
import axios from 'axios'
import { useLangStore } from './langStore'

export const useExhibitionPageStore = defineStore('exhibitionPage', {
  state: () => ({
    exhibition: {
        data: [],
        exhibitionName_TR: '',
        exhibitionName_EN: '',
        exhibitionInfo_TR: '',
        exhibitionInfo_EN: '',
    },
    isLoading: false
  }),
  getters: {
    // Dile göre filtrelenmiş liste
    filteredImages: (state) => {
      const lang = useLangStore().language;
      return state.exhibition.data.map(item => ({
        imageName: item.imageName,
        imageInfo: lang === 'tr' ? item.imageInfo_TR : item.imageInfo_EN
      }));
    },
    exhibitionNameFiltered: (state) => {
      const lang = useLangStore().language;
      return lang === 'tr' ? state.exhibition.exhibitionName_TR : state.exhibition.exhibitionName_EN;
    },
    exhibitionInfoFiltered: (state) => {
      const lang = useLangStore().language;
      return lang === 'tr' ? state.exhibition.exhibitionInfo_TR : state.exhibition.exhibitionInfo_EN;
    }
  },
  actions: {
    async fetchExhibitionData() {
      if (this.exhibition.data.length > 0) return;  // Daha önce yüklendiyse tekrar çekme
      this.isLoading = true;
      try {
        const res = await axios.get('/api-path/Exhibition/get-all-images');
        this.exhibition.data = res.data.data;
        this.exhibition.exhibitionName_TR = res.data.exhibitionName_TR;
        this.exhibition.exhibitionName_EN = res.data.exhibitionName_EN;
        this.exhibition.exhibitionInfo_TR = res.data.exhibitionInfo_TR;
        this.exhibition.exhibitionInfo_EN = res.data.exhibitionInfo_EN;
      } catch (err) {
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    }
  }
});